import { Commit } from 'vuex';
import { ErrorToasterState } from './state';

export interface EmmirErrorActionType{
    commit: Commit
    state: ErrorToasterState
}

export enum ErrorAction {
    DEACTIVATE_TOAST = 'DEACTIVATE_TOAST'
}